/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../notes/notes.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareVehicleFactory {
        // Methods
        loadVehicle(locationId: number, id: number) : ng.IPromise<{}>;
        getInstance() : IDealerwareVehicle;
    }

    export interface IDealerwareVehicle extends IDealerwareHasNotes {
        // Properties
        vehicleId: number;

        // Models
        vehicleDetails: any;
        qrCode: any;
        vehicleStates: any;
        vehicleIssues: any;
        vehicleScans: any;
        vehicleContracts: any;
        tollHistory: any;

        // Methods
        clear() : void;
        clearVehicleDetails() : void;
        loadVehicleDetails(locationId?: number, id?: number) : ng.IPromise<{}>;
        loadQrCode(id?: number) : ng.IPromise<{}>;
        loadVehicleStates(id?: number) : ng.IPromise<{}>;
        updateVehicleState(id: number, newState: string) : ng.IPromise<{}>;
        loadVehicleIssues(id?: number) : ng.IPromise<{}>;
        loadVehicleScans() : ng.IPromise<{}>;
        loadVehicleContracts(id?: number) : ng.IPromise<{}>;
        loadNotes() : ng.IPromise<{}>;
        loadTollHistory(id?: number) : ng.IPromise<{}>;
    }
}